import {
	IInitialFormData,
	TEditVideoSelectedItem,
	TEditVideoVisibleForm,
	TTypeOfEditVideoModalWindow,
} from './editVideoContext';
import { IMenuTranslation, IItemForGetShortInfo, TFileId, TLanguageIDs, IFileData, IEditVideo } from 'types';

export enum EditVideoActionTypes {
	REFETCH_DATA = 'REFETCH_DATA',
	SET_INITIAL_FORM_DATA = 'SET_INITIAL_FORM_DATA',
	SET_ALL_DATA = 'SET_ALL_DATA',
	CHANGE_VISIBLE_FORM = 'CHANGE_VISIBLE_FORM',
	SET_FILE_ID = 'SET_FILE_ID',
	DELETE_PHOTO = 'DELETE_PHOTO',
	SET_FETCHED_STUDIOS = 'SET_FETCHED_STUDIOS',
	SET_ID_STUDIO = 'SET_ID_STUDIO',
	REFETCH_STUDIOS = 'REFETCH_STUDIOS',
	CHANGE_NAME = 'CHANGE_NAME',
	SET_FETCHED_CATEGORIES = 'SET_FETCHED_CATEGORIES',
	SET_ID_CATEGORY = 'SET_ID_CATEGORY',
	CHANGE_FILE_DATA = 'CHANGE_FILE_DATA',
	SET_FETCHED_LANGUAGES = 'SET_FETCHED_LANGUAGES',
	SET_IDs_LANGUAGES = 'SET_IDs_LANGUAGES',
	SET_DATA_FOR_SUBMIT = 'SET_DATA_FOR_SUBMIT',
	CHANGE_TYPE_OF_MODAL_WINDOW = 'CHANGE_TYPE_OF_MODAL_WINDOW',
	SET_TRANSLATION_TAB = 'SET_TRANSLATION_TAB',
	SET_TRANSLATION_FIELDS = 'SET_TRANSLATION_FIELDS',
	CHANGE_TRANSLATION = 'CHANGE_TRANSLATION',
	RESET_FIELDS = 'RESET_FIELDS',
}

interface IRefetchData {
	type: EditVideoActionTypes.REFETCH_DATA;
	payload: {
		needRefetch: boolean;
	};
}

interface ISetInitialFormData {
	type: EditVideoActionTypes.SET_INITIAL_FORM_DATA;
	payload: {
		initialFormData: IInitialFormData;
	};
}

interface ISetAllData {
	type: EditVideoActionTypes.SET_ALL_DATA;
	payload: {
		videoID: string;
		IDSelectedStudio: TEditVideoSelectedItem;
		name: string;
		IDSelectedCategory: TEditVideoSelectedItem;
		IDsSelectedLanguages: TLanguageIDs[];
		translations: IMenuTranslation[];
		videoPath: string;
		iconPath: string;
	};
}

interface IChangeVisibleForm {
	type: EditVideoActionTypes.CHANGE_VISIBLE_FORM;
	payload: {
		visibleForm: TEditVideoVisibleForm;
	};
}

interface ISetFileId {
	type: EditVideoActionTypes.SET_FILE_ID;
	payload: {
		fileId: TFileId;
	};
}

interface IDeletePhoto {
	type: EditVideoActionTypes.DELETE_PHOTO;
}

interface ISetFetchedStudios {
	type: EditVideoActionTypes.SET_FETCHED_STUDIOS;
	payload: {
		studios: IItemForGetShortInfo[];
	};
}

interface ISetIDStudio {
	type: EditVideoActionTypes.SET_ID_STUDIO;
	payload: {
		IDStudio: TEditVideoSelectedItem;
	};
}

interface IRefetchStudios {
	type: EditVideoActionTypes.REFETCH_STUDIOS;
	payload: {
		needRefetch: boolean;
	};
}

interface IChangeName {
	type: EditVideoActionTypes.CHANGE_NAME;
	payload: {
		name: string;
	};
}

interface ISetFetchedCategories {
	type: EditVideoActionTypes.SET_FETCHED_CATEGORIES;
	payload: {
		categories: IItemForGetShortInfo[];
	};
}

interface ISetIDCategory {
	type: EditVideoActionTypes.SET_ID_CATEGORY;
	payload: {
		IDCategory: TEditVideoSelectedItem;
	};
}

interface IChangeFileHash {
	type: EditVideoActionTypes.CHANGE_FILE_DATA;
	payload: {
		fileData: IFileData;
	};
}

interface ISetFetchedLanguages {
	type: EditVideoActionTypes.SET_FETCHED_LANGUAGES;
	payload: {
		languages: IItemForGetShortInfo[];
	};
}

interface ISetIDsLanguages {
	type: EditVideoActionTypes.SET_IDs_LANGUAGES;
	payload: {
		IDsLanguages: TLanguageIDs[];
	};
}

interface ISetDataForSubmit {
	type: EditVideoActionTypes.SET_DATA_FOR_SUBMIT;
	payload: {
		data: IEditVideo | null;
	};
}

interface IChangeTypeOfModalWindow {
	type: EditVideoActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW;
	payload: {
		typeOfModalWindow: TTypeOfEditVideoModalWindow;
	};
}

interface ISetTranslationTab {
	type: EditVideoActionTypes.SET_TRANSLATION_TAB;
	payload: {
		translationTab: TLanguageIDs | null;
	};
}

interface ISetTranslationFields {
	type: EditVideoActionTypes.SET_TRANSLATION_FIELDS;
	payload: {
		updatedTranslations: IMenuTranslation[];
	};
}

interface IChangeTranslation {
	type: EditVideoActionTypes.CHANGE_TRANSLATION;
	payload: {
		updatedTranslations: IMenuTranslation[];
	};
}

interface IResetSelectedControls {
	type: EditVideoActionTypes.RESET_FIELDS;
}

export type TEditVideoAction =
	| IRefetchData
	| ISetInitialFormData
	| ISetAllData
	| IChangeVisibleForm
	| ISetFileId
	| IDeletePhoto
	| ISetFetchedStudios
	| ISetIDStudio
	| IRefetchStudios
	| ISetFetchedCategories
	| ISetIDCategory
	| IChangeName
	| IChangeFileHash
	| ISetFetchedLanguages
	| ISetIDsLanguages
	| ISetDataForSubmit
	| IChangeTypeOfModalWindow
	| ISetTranslationTab
	| ISetTranslationFields
	| IChangeTranslation
	| IResetSelectedControls;
